class Emergency {
  constructor(element) {
    this.element = element;
    this.openClass = 'is-open';
    this.$open = this.element.querySelector('.js-emergency-open');
    this.$close = this.element.querySelector('.js-emergency-close');
    this.$open.addEventListener('click', this.toggleState.bind(this));
    this.$close.addEventListener('click', this.toggleState.bind(this));
  }

  toggleState(e) {
    e.preventDefault();
    if (this.element.classList.contains(this.openClass)) {
      this.element.classList.remove(this.openClass);
    } else {
      this.element.classList.add(this.openClass);
    }
    return false;
  }
}

export default Emergency;
